import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../../components/ExcelExportMenu';
import TableConstantActions from '../../../../../components/TableConstantActions';
import { ExcelExportMode } from '../../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../../models/common/ColumnChooserModel';
import { RootState } from '../../../../../redux/store';
import { SigortaListIstegi } from '../../../../../services/SigortaService';
import { MenuComponent } from '../../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: SigortaListIstegi
    setFilter: React.Dispatch<React.SetStateAction<SigortaListIstegi>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    copyFunction: () => void
    onSearchSubmit: (e: any) => void
    sigortasizAraclar: () => void
}

/**
 * Sigorta / Kasko liste araç çubuğu: arama (poliçe no + açıklama), güncelle / sil, Kopyala (tek satır seçiliyken;
 * yeni yılın poliçesi), kolon seçici, Excel, Sigortasız Araçlar, yeni kayıt.
 */
const SigortaListFilters = ({ columns, setColumns, getColumns, pageName, pageVersion, excelExport, filter, setFilter, selectedCount, deleteFunction, updateFunction, copyFunction, onSearchSubmit, sigortasizAraclar }: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)
    const ekleyebilir = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert;

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                hideSearch
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            {
                ekleyebilir && (
                    <button
                        onClick={copyFunction}
                        disabled={selectedCount != 1}
                        title={selectedCount != 1 ? 'Kopyalamak için tek poliçe seçin' : 'Seçilen poliçeden yeni yılın poliçesini oluştur'}
                        className='btn btn-sm btn-flex btn-light-primary'
                    >
                        <i className='fa fa-copy fs-6 me-1' />
                        Kopyala
                    </button>
                )
            }

            <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

            <ExcelExportMenu pageName={pageName} selectedCount={selectedCount} onExport={excelExport} />

            <button onClick={sigortasizAraclar} className='btn btn-sm btn-flex btn-light-danger'>
                <i className='fa fa-car fs-6 me-1' />
                Sigortasız Araçlar
            </button>

            {
                ekleyebilir && (
                    <div className='m-0'>
                        <a onClick={() => navigate('/sigorta/listadd')} className='btn btn-sm fw-bold btn-primary'>Yeni Kayıt Ekle</a>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default SigortaListFilters;
